import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import {Modal} from "react-bootstrap";
import {baseUrl, ipAddress, userName} from "../Univ";
function Document() {
    // ==========================================
    // STATES
    // ==========================================
    const [documents, setDocuments] = useState([]);
    const [loading, setLoading] = useState(false);
    // Upload Modal
    const [showModal, setShowModal] = useState(false);
    // Viewer Modal
    const [viewerOpen, setViewerOpen] = useState(false);
    // Files in current document
    const [viewerFiles, setViewerFiles] = useState([]);
    // Current image/document index
    const [currentIndex, setCurrentIndex] = useState(0);
    // Upload Form
    const [formData, setFormData] = useState({
        document_type: "", document_id: "", title: "", file: [], uploaded_by: userName
    });
    // ==========================================
    // LOAD DOCUMENTS
    // ==========================================
    useEffect(() => {
        getDocuments();
    }, []);
    // ==========================================
    // GET DOCUMENTS
    // ==========================================
    const getDocuments = () => {
        setLoading(true);
        axios.get(baseUrl + "document/")
            .then((res) => {
                setDocuments(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                Swal.fire("Error", "Unable to load documents.", "error");
            });
    };
    // ==========================================
    // INPUT CHANGE
    // ==========================================
    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData(prev => ({
            ...prev, [name]: value
        }));
    };
    // ==========================================
    // FILE SELECT
    // ==========================================
    const handleFile = (e) => {
        setFormData(prev => ({
            ...prev, file: Array.from(e.target.files)
        }));
    };
    // ==========================================
    // OPEN/CLOSE UPLOAD MODAL
    // ==========================================
    const openModal = () => {
        setFormData({
            document_type: "", document_id: "", title: "", file: [], uploaded_by: userName
        });
        setShowModal(true);
    };
    const closeModal = () => {
        setShowModal(false);
    };
// ==========================================
// UPLOAD DOCUMENT
// ==========================================
    const uploadDocument = () => {
        if (!formData.document_type) {
            Swal.fire("Warning", "Please select a module.", "warning");
            return;
        }
        if (!formData.document_id) {
            Swal.fire("Warning", "Please enter Document ID.", "warning");
            return;
        }
        if (!formData.title) {
            Swal.fire("Warning", "Please enter title.", "warning");
            return;
        }
        if (formData.file.length === 0) {
            Swal.fire("Warning", "Please select at least one file.", "warning");
            return;
        }
        const data = new FormData();
        data.append("document_type", formData.document_type);
        data.append("document_id", formData.document_id);
        data.append("title", formData.title);
        data.append("uploaded_by", userName);
        data.append("ip_address", ipAddress);
        formData.file.forEach((f) => {
            data.append("file", f);
        });
        axios.post(baseUrl + "document/", data)
            .then(() => {
                Swal.fire({
                    icon: "success", title: "Uploaded Successfully", timer: 1500, showConfirmButton: false
                });
                closeModal();
                getDocuments();
            })
            .catch(() => {
                Swal.fire("Error", "Unable to upload document.", "error");
            });
    };
// ==========================================
// DELETE DOCUMENT
// ==========================================
    const deleteDocument = (id) => {
        Swal.fire({
            title: "Delete Document?",
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Delete",
            cancelButtonText: "Cancel"
        }).then((result) => {
            if (!result.isConfirmed) return;
            axios.delete(baseUrl + "update-document/" + id + "/")
                .then(() => {
                    Swal.fire("Deleted", "Document deleted successfully.", "success");
                    getDocuments();
                })
                .catch(() => {
                    Swal.fire("Error", "Unable to delete document.", "error");
                });
        });
    };
// ==========================================
// OPEN FILE VIEWER
// ==========================================
    const openViewer = (fileString) => {
        const files = fileString
            .split(",")
            .map(f => "https://eagri.mgmebuild.com/media/" + f.trim());
        setViewerFiles(files);
        setCurrentIndex(0);
        setViewerOpen(true);
    };
// ==========================================
// CLOSE VIEWER
// ==========================================
    const closeViewer = () => {
        setViewerOpen(false);
        setViewerFiles([]);
        setCurrentIndex(0);
    };
// ==========================================
// NEXT FILE
// ==========================================
    const nextFile = () => {
        if (currentIndex < viewerFiles.length - 1) setCurrentIndex(currentIndex + 1);
    };
// ==========================================
// PREVIOUS FILE
// ==========================================
    const previousFile = () => {
        if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
    };
// ==========================================
// CURRENT FILE
// ==========================================
    const currentFile = viewerFiles.length > 0 ? viewerFiles[currentIndex] : "";
// ==========================================
// FILE EXTENSION
// ==========================================
    const extension = currentFile ? currentFile.split(".").pop().toLowerCase() : "";
// ==========================================
// IMAGE FILE ?
// ==========================================
    const isImage = ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(extension);
// ==========================================
// PDF FILE ?
// ==========================================
    const isPDF = extension === "pdf";
// ==========================================
// OFFICE DOCUMENT ?
// ==========================================
    const isOffice = ["doc", "docx", "xls", "xlsx", "ppt", "pptx", "csv", "zip"].includes(extension);
// ==========================================
// DOWNLOAD FILE
// ==========================================
    const downloadCurrentFile = () => {
        window.open(currentFile, "_blank");
    };
    return (<div className="container-fluid mt-4">

            {/* ================= HEADER ================= */}

            <div className="card shadow border-0">

                <div className="card-header bg-success text-white d-flex justify-content-between align-items-center">

                    <div>

                        <h4 className="mb-0">
                            📁 Agri ERP Document Manager
                        </h4>

                        <small>
                            Store Images, PDFs & Documents for every ERP module
                        </small>

                    </div>

                    <button
                        className="btn btn-light fw-bold"
                        onClick={openModal}
                    >
                        <i className="fa fa-upload me-2"></i>
                        Upload Document
                    </button>

                </div>

            </div>


            {/* ================= LOADING ================= */}

            {loading && <div className="alert alert-info mt-3">

                Loading Documents...

            </div>}


            {/* ================= EMPTY ================= */}

            {!loading && documents.length === 0 && <div className="alert alert-warning mt-3">

                No documents uploaded.

            </div>}


            {/* ================= DOCUMENT GRID ================= */}

            <div className="row mt-3">

                {documents.map((doc) => {
                    const files = doc.file ? doc.file.split(",").filter(f => f.trim() !== "") : [];
                    return (<div
                            className="col-xl-3 col-lg-4 col-md-6 mb-4"
                            key={doc.id}
                        >

                            <div className="card h-100 shadow-sm border-0 document-card">

                                <div className="card-header bg-primary text-white">

                                    <h6 className="mb-0">

                                        {doc.title}

                                    </h6>

                                </div>


                                <div className="card-body">

                                    <p className="mb-2">

                                        <strong>Module</strong>

                                        <br/>

                                        {doc.document_type}

                                    </p>


                                    <p className="mb-2">

                                        <strong>Reference ID</strong>

                                        <br/>

                                        {doc.document_id}

                                    </p>


                                    <p className="mb-2">

                                        <strong>Uploaded By</strong>

                                        <br/>

                                        {doc.uploaded_by}

                                    </p>


                                    <p className="mb-2">

                                        <strong>Uploaded On</strong>

                                        <br/>

                                        {new Date(doc.uploaded_date).toLocaleString()}

                                    </p>


                                    <span className="badge bg-success">

                                    {files.length} File(s)

                                </span>

                                </div>


                                <div className="card-footer bg-white">

                                    <div className="d-grid gap-2">

                                        <button

                                            className="btn btn-primary"

                                            onClick={() => openViewer(doc.file)}

                                        >

                                            👁 View Files

                                        </button>


                                        <button

                                            className="btn btn-danger"

                                            onClick={() => deleteDocument(doc.id)}

                                        >

                                            🗑 Delete

                                        </button>

                                    </div>

                                </div>

                            </div>

                        </div>);
                })}

            </div>
            {/* =========================================================
                        FILE VIEWER
========================================================= */}

            <Modal
                show={viewerOpen}
                onHide={closeViewer}
                size="xl"
                centered
            >

                <Modal.Header closeButton>

                    <Modal.Title>

                        File {currentIndex + 1} of {viewerFiles.length}

                    </Modal.Title>

                </Modal.Header>

                <Modal.Body className="text-center">

                    {viewerFiles.length > 0 && <>

                        {isImage && <img

                            src={currentFile}

                            alt=""

                            className="img-fluid rounded"

                            style={{
                                maxHeight: "75vh", objectFit: "contain"
                            }}

                        />}

                        {isPDF && <iframe

                            src={currentFile}

                            title="PDF"

                            width="100%"

                            height="700"

                            style={{
                                border: "none"
                            }}

                        />}

                        {isOffice && <div className="py-5">

                            <i

                                className="fa fa-file fa-5x text-primary mb-3"

                            />

                            <h5>

                                Preview unavailable.

                            </h5>

                            <p>

                                Click below to open or download the file.

                            </p>

                            <button

                                className="btn btn-primary"

                                onClick={downloadCurrentFile}

                            >

                                Open Document

                            </button>

                        </div>}

                    </>}

                </Modal.Body>

                <Modal.Footer>

                    <button

                        className="btn btn-secondary"

                        disabled={currentIndex === 0}

                        onClick={previousFile}

                    >

                        ◀ Previous

                    </button>

                    <button

                        className="btn btn-success"

                        onClick={downloadCurrentFile}

                    >

                        Download

                    </button>

                    <button

                        className="btn btn-secondary"

                        disabled={currentIndex === viewerFiles.length - 1}

                        onClick={nextFile}

                    >

                        Next ▶

                    </button>

                </Modal.Footer>

            </Modal>


            {/* =========================================================
                    UPLOAD MODAL
========================================================= */}

            <Modal
                show={showModal}
                onHide={closeModal}
                size="lg"
                centered
            >

                <Modal.Header closeButton>

                    <Modal.Title>

                        Upload Document

                    </Modal.Title>

                </Modal.Header>

                <Modal.Body>

                    <div className="row">

                        <div className="col-md-6 mb-3">

                            <label className="form-label">

                                Module

                            </label>

                            <select

                                className="form-control"

                                name="document_type"

                                value={formData.document_type}

                                onChange={handleChange}

                            >

                                <option value="">Select Module</option>

                                <option>Masters</option>

                                <option>Land Management</option>

                                <option>Worker Management</option>

                                <option>Crop Management</option>

                                <option>Inventory Management</option>

                                <option>Warehouse Management</option>

                                <option>Procurement Management</option>

                                <option>Machine Management</option>

                                <option>Workflow & Approval</option>

                                <option>Notification Engine</option>

                                <option>Document Management</option>

                                <option>Audit Log</option>

                                <option>E-Commerce</option>

                                <option>Logistics & Fleet</option>

                                <option>Order Tracking</option>

                                <option>Finance</option>

                                <option>Reports & Analytics</option>

                                <option>Settings</option>

                            </select>

                        </div>

                        <div className="col-md-6 mb-3">

                            <label>

                                Document ID

                            </label>

                            <input

                                className="form-control"

                                name="document_id"

                                value={formData.document_id}

                                onChange={handleChange}

                            />

                        </div>

                        <div className="col-12 mb-3">

                            <label>

                                Title

                            </label>

                            <input

                                className="form-control"

                                name="title"

                                value={formData.title}

                                onChange={handleChange}

                            />

                        </div>

                        <div className="col-12 mb-3">

                            <label>

                                Upload Files

                            </label>

                            <input

                                type="file"

                                className="form-control"

                                multiple

                                onChange={handleFile}

                            />

                        </div>

                        {formData.file.length > 0 && <div className="col-12">

                            <div className="alert alert-info">

                                <strong>

                                    Selected Files

                                </strong>

                                <hr/>

                                {formData.file.map((file, index) => (<div key={index}>

                                        📄 {file.name}

                                    </div>))}

                            </div>

                        </div>}

                    </div>

                </Modal.Body>

                <Modal.Footer>

                    <button

                        className="btn btn-secondary"

                        onClick={closeModal}

                    >

                        Close

                    </button>

                    <button

                        className="btn btn-success"

                        onClick={uploadDocument}

                    >

                        Upload

                    </button>

                </Modal.Footer>

            </Modal>
        </div>);
}
export default Document;